import * as React from 'react';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';

import DoneIcon from 'material-ui/svg-icons/action/done';

type ListItemProps = __MaterialUI.List.ListItemProps;

interface Item {
    id: number;
    label: string;
}

export interface SelectableListProps {
    items: Item[];
    selectedItem: Item;
    style?: React.CSSProperties;
    title?: string;
    titleStyle?: React.CSSProperties;
    dataTestId?: string;
    renderItem?(item: Item): React.ReactElement<ListItemProps>;
    onItemSelect?(item: Item): void;
    onPreviewedItemChange?(item: Item): void;
}

interface SelectableListState {
    activeItem: Item;
    hoveredItem: Item;
}

export class SelectableList extends React.Component<SelectableListProps, SelectableListState> {
    constructor(props: SelectableListProps, context?: any) {
        super(props, context);

        this.state = {
            activeItem: this.props.selectedItem,
            hoveredItem: null
        };
    }

    componentWillReceiveProps(props: SelectableListProps) {
        if (props.selectedItem !== this.state.activeItem) {
            this.setState({
                activeItem: props.selectedItem
            } as SelectableListState);
        }
    }

    componentDidUpdate(prevProps: SelectableListProps, prevState: SelectableListState) {
        let previewedItem = this.getPreviewedItem(this.state);
        if (previewedItem !== this.getPreviewedItem(prevState)) {
            if (this.props.onPreviewedItemChange) {
                this.props.onPreviewedItemChange(previewedItem);
            }
        }
    }

    render() {
        return (
            <div>
            {this.props.title ?
                <div style={this.props.titleStyle}> {this.props.title}</div>
            : null}
                <List style={this.props.style} data-test-id={this.props.dataTestId}>
                    {this.props.items.map(i => this.renderItem(i))}
                </List>
            </div>
        );
    }

    private renderItem(i: Item) {
        let baseItemProps = {
            onClick: () => this.onItemClick(i),
            onMouseEnter: () => this.onItemHover(i),
            onMouseLeave: () => this.onItemHoverOut(i),
            style: this.getItemStyle(i)
        } as ListItemProps;

        if (this.props.renderItem) {
            let listItem = this.props.renderItem(i);
            return React.cloneElement(listItem, baseItemProps);
        }

        let dataTestId = this.props.dataTestId ? this.props.dataTestId + '-' + i.id : void 0;

        return (
            <ListItem
                key={i.id}
                primaryText={i.label}
                insetChildren={true}
                innerDivStyle={{paddingLeft: 56}}
                leftIcon={this.props.selectedItem === i ? <DoneIcon/> : null}
                data-test-id={dataTestId}
                {...baseItemProps}
            />
        );
    }

    private onItemClick(item: Item) {
        this.setState({activeItem: item} as SelectableListState);
        if (this.props.onItemSelect) {
            this.props.onItemSelect(item);
        }
    }

    private getPreviewedItem(state: SelectableListState) {
        return state.hoveredItem || state.activeItem;
    }

    private onItemHover(item: Item) {
        this.setState({hoveredItem: item} as SelectableListState);
    }

    private onItemHoverOut(item: Item) {
        if (this.state.hoveredItem !== item) {
            return;
        }
        this.setState({hoveredItem: null} as SelectableListState);
    }

    private getItemStyle(item: Item) {
        let activeStyles = {
            color: "#16191d",
            backgroundColor: "#ced0d6"
        };

        let style = {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            color: 'rgba(61, 73, 89, 1)'
        };

        if (item === this.state.activeItem) {
            Object.assign(style, activeStyles);
        }

        return style;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/advanced/SelectableList.tsx
 **/